import { AttachedCardPaymentMethod } from '@mews-commander/data-access';
import { DropdownItem, Stack } from '@optimus-web/core';
import { FormSelectField, lt } from '@mews/framework';
import { SelectFieldProps } from '@mews-commander/form';
import { createCardLabel } from '@mews-commander/legacy-entities/src/ducks/paymentCards';
import PaymentCardIcon from '../../../../../../components/commander-ui/PaymentCardIcon';
import { useDefaultFormContext } from '../useDefaultFormValues';

interface ChargeablePreauthCardProps extends Omit<SelectFieldProps, 'options'> {
    chargeablePreauthCard?: AttachedCardPaymentMethod;
    accountId: string;
}

const PaymentMethodFormSelectIcon = ({
    chargeablePreauthCard,
}: {
    chargeablePreauthCard?: AttachedCardPaymentMethod;
}) => (chargeablePreauthCard ? <PaymentCardIcon type={chargeablePreauthCard.type} width={24} /> : null);

export const ChargePreauthorizationPaymentCardSelectField = ({
    name,
    chargeablePreauthCard,
    readOnly,
    ...other
}: ChargeablePreauthCardProps) => {
    const {
        readOnlyFormFields: { isPaymentMethodIdReadOnly },
    } = useDefaultFormContext();

    return (
        <FormSelectField
            name={name}
            data-test-select-name={name}
            label={lt('ProcessPaymentMewsPaymentsPaymentMethodSelectLabel')}
            helper={lt('ProcessPaymentMewsPaymentsPaymentMethodSelectHelper')}
            readOnly={readOnly || isPaymentMethodIdReadOnly}
            defaultValue={chargeablePreauthCard?.id}
            displayMapper={(i: React.ReactElement) => (
                <Stack spacing="100">
                    <PaymentMethodFormSelectIcon chargeablePreauthCard={chargeablePreauthCard} />
                    {i.props.label}
                </Stack>
            )}
            {...other}
        >
            {chargeablePreauthCard && (
                <DropdownItem
                    label={createCardLabel(chargeablePreauthCard)}
                    value={chargeablePreauthCard.id}
                    data-test-select-item-value={chargeablePreauthCard.id}
                    key={chargeablePreauthCard.id}
                />
            )}
        </FormSelectField>
    );
};
